





















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class CatalogIcon extends Vue {
  @Prop({ type: String, default: 'catalog' })
  readonly type!: string;

  @Prop({ type: String, default: '#fff' })
  readonly defaultColor!: string;

  @Prop({ type: String, default: '#6e6bce' })
  readonly activeColor!: string;

  @Prop({ type: Boolean, default: false })
  readonly selected!: boolean;

  get color(): any {
    const { defaultColor, activeColor, selected, type } = this;
    return (type === 'catalog' && selected) || (type === 'map' && !selected)
      ? {
          catalog: activeColor,
          map: defaultColor,
        }
      : {
          catalog: defaultColor,
          map: activeColor,
        };
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/nav/switcher/components/Icon.vue